import { render, staticRenderFns } from "./index.vue?vue&type=template&id=288b806e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=288b806e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b806e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {News: require('/var/jenkins_home/workspace/prod-web-xfans/components/news.vue').default,NewsSmall: require('/var/jenkins_home/workspace/prod-web-xfans/components/news_small.vue').default})
